import React, { useEffect, useState, useCallback, useContext } from 'react';
import { Grid } from '@mui/material';
import AccountLogo from './AccountLogo';
import AccountInfo from './AccountInfo';
import { getProfileInfo, updateProfile } from 'core/services/profile';
import { useSnackbar } from 'notistack';
import { AuthContext } from 'core/context';

const Account = () => {
  /** Declarations */
  const defaultAccountFields = {
    'firstName': '',
    'lastName': '',
    'mobile': '',
    'email': '',
    'active': true,
  };
  
  /** Hooks */
  const { enqueueSnackbar } = useSnackbar();
  const [accountDetails, setAccountDetails] = useState(defaultAccountFields);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const { updateAuthContext } = useContext(AuthContext)

  useEffect(() => {
    getAccountDetails();
  }, []);

  function getAccountDetails() {
    getProfileInfo().then(({response, error}) => {
      if(response){
        setAccountDetails({
          firstName: response?.firstName || '',
          lastName: response?.lastName || '',
          email: response?.email || '',
          mobile: response?.mobile || '',
          active: response?.active || true,
        });
        const {userId} = response;
        if(userId){
          const photoURL=`/vendor/rest/images/${userId}/profilePhoto.jpg`
          setProfilePhoto(photoURL);
        }
      }else{
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  const updateProfileInfo = useCallback(
    (data) => {
      updateProfile(data).then(({response, error}) => {
        if(response){
          updateAuthContext({data: {name: `${data.firstName} ${data.lastName}`, email: data.email}});
          enqueueSnackbar((response?.message || 'Account details updated successfully'), {variant: 'success'});
      }else{
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
      })
    },
    [enqueueSnackbar, updateAuthContext],
  );

  return (
  <Grid container spacing={3} sx={{pt: 2}}>
    <Grid item xs={12} md={3}  sm={12} lg={4}>
      <AccountLogo accountDetails={accountDetails} profilePhoto={profilePhoto} />
    </Grid>
    <Grid item xs={12} sm={12} md={9} lg={8}>
      <AccountInfo accountDetails={accountDetails} updateProfileInfo={updateProfileInfo}/>
    </Grid>
  </Grid>
  );
}
 
export default Account;
